/** @override King Living: BaseSplitPanelDoubleImageBlockFragment with CF-07 backgroundColour, textColour. */

import gql from 'graphql-tag';

export const BaseSplitPanelDoubleImageBlockFragment = gql`
  fragment BaseSplitPanelDoubleImageBlockFragment on SplitPanelDoubleImageBlock {
    __typename
    sys {
      id
    }
    backgroundColour
    jumpLink
    jumpLinkMarginTop
    mediaPosition
    textColour
    title
  }
`;
